import endpoints_auth from "./endpoints/endpoints-auth";
import endpoints_federation from "./endpoints/endpoints-federation";
import endpoints_organizations from "./endpoints/endpoints-organizations";
import endpoints_resellers from "./endpoints/endpoints-resellers";
import endpoints_users from "./endpoints/endpoints-users";


export default {
    ...endpoints_auth,
    ...endpoints_federation,
    ...endpoints_organizations,
    ...endpoints_resellers,
    ...endpoints_users
}